import React from 'react';
import connectionSources from './connectionSources';
import { TextBlock, Text } from 'bench-internal-theme';
import ConnectionCard from './connection-card/ConnectionCard';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import breakpoints from '../constants/breakpoints';
import { colors } from 'bench-style-constants';
import { Connection, ConnectionSource } from './types';

const ConnectionSection = styled.section`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;
`;

type ConnectionCardsLayoutProps = {
  isDesktop: boolean;
};

const ConnectionCardsLayout = styled.div<ConnectionCardsLayoutProps>`
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;
  ${({ isDesktop }) => isDesktop && `grid-template-columns: 1fr 1fr`};
`;

type ConnectionsProps = {
  connectionsBySource: { [key in ConnectionSource]?: Connection[] };
};

const Connections = ({ connectionsBySource }: ConnectionsProps) => {
  const isDesktop = useMediaQuery({ minWidth: breakpoints.ld });

  return (
    <>
      {connectionSources.map(({ source, displayName }) => {
        const connectionsForSource = connectionsBySource[source] || [];

        return (
          <ConnectionSection key={source}>
            <TextBlock styleType="largeBold">{displayName}</TextBlock>
            {connectionsForSource.length === 0 ? (
              <Text styleType="small" color={colors.cloud}>
                {`Client has no ${displayName} connections.`}
              </Text>
            ) : (
              <ConnectionCardsLayout isDesktop={isDesktop}>
                {connectionsForSource.map(connection => (
                  <ConnectionCard key={connection.id} connection={connection} />
                ))}
              </ConnectionCardsLayout>
            )}
          </ConnectionSection>
        );
      })}
    </>
  );
};

export default Connections;
